export default function SeriesOverview() {
  const highlights = [
    {
      icon: 'ri-building-4-line',
      title: 'Prefabricated Construction',
      description: 'Designed to reduce on-site disruption, noise and construction waste through controlled off-site assembly processes.'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Durable Material Systems',
      description: 'Aluminium and stainless-steel material systems selected for longevity, corrosion resistance and end-of-life recyclability.'
    },
    {
      icon: 'ri-landscape-line',
      title: 'Panoramic Design',
      description: 'Panoramic glazing and considered layouts that connect guests with surrounding landscapes and natural light.'
    },
    {
      icon: 'ri-stack-line',
      title: 'Flexible Configurations',
      description: 'Customisable configurations suited to hospitality, glamping, private retreats and flexible accommodation needs.'
    }
  ];

  return (
    <section className="py-20 sm:py-28 lg:py-36 bg-gradient-to-b from-[#000000] via-[#0D1117] to-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 sm:mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6 text-white">
            The <span className="text-cyan-400">X Series</span> Advantage
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            The X Series brings together prefabricated construction, durable material systems and thoughtful design to create living spaces that perform across hospitality, residential and retreat settings.
          </p>
        </div>

        {/* Highlights Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {highlights.map((highlight, index) => (
            <div 
              key={index}
              className="group relative bg-black/50 backdrop-blur-sm border border-cyan-500/20 rounded-2xl p-8 hover:border-cyan-500/50 hover:shadow-[0_0_30px_rgba(0,217,255,0.2)] transition-all duration-300"
            >
              <div className="w-14 h-14 bg-cyan-500 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:shadow-[0_0_20px_rgba(0,217,255,0.5)] transition-all">
                <i className={`${highlight.icon} text-2xl text-black`}></i>
              </div>
              <h3 className="text-xl font-medium text-white mb-3">{highlight.title}</h3>
              <p className="text-base text-gray-400 leading-relaxed">{highlight.description}</p>
            </div>
          ))}
        </div>

        {/* Feature Image */}
        <div className="mt-16 sm:mt-20 relative">
          <div className="relative w-full h-[400px] sm:h-[500px] lg:h-[600px] rounded-3xl overflow-hidden border border-cyan-500/20 shadow-[0_0_40px_rgba(0,217,255,0.15)]">
            <img 
              src="/images/ai-luxury-dark-prefabricated-capsule-house--173b1d.webp"
              alt="X Series Interior"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
            <div className="absolute bottom-8 left-8 right-8 text-white">
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-light mb-3">Designed for <span className="text-cyan-400">Lasting Performance</span></h3>
              <p className="text-base sm:text-lg text-gray-300 max-w-2xl">
                Every X Series pod combines considered design with durable material systems, creating spaces that perform across a wide range of settings and conditions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}